<template>
    <div id="contrata-ya-landing">
        <div class="container pb-4 pt-4">

            <div id="LandingHeader" class="pt-4 mb-4 text-center">

                <b-card-title>
                    {{ generalTitle }}
                </b-card-title>

                <template v-if="!hideProgressBar">
                    <b-progress height="20px" class="mb-2">
                        <b-progress-bar :value="cStepProgress" :max="(stepKeys.length - 1)" variant="success">
                            <!-- {{ cStepLabel }} -->
                        </b-progress-bar>
                    </b-progress>
    
                    <b-card-title class="sub">
                        {{ stepSubtitles[stepKeys[cStepProgress - 1]] }}
                    </b-card-title>
                </template>


            </div>

            <template v-if="cStep == SELECCIONA_OFERTA">
                <products-viewer class="mt-5 mb-5" v-model="form.selectedOffer" ref="productsViewer" 
                    :only-mifi="onlyMifi"
                    @selectedOffer="updatePrice" 
                    @goNext="triggerNextStep"/>
                <b-card class="text-right mt-4 bg-primary" v-if="!hideFirstNextBCard">
                    <b-button :variant="cStepProgress === stepKeys.length ? 'success' : 'primary'"
                        @click="triggerNextStep" :disabled="isNextDisabled">
                        {{ cNextLabel }}
                    </b-button>
                </b-card>
            </template>

            <b-row class="mt-5 mb-5" v-else>

                <b-col id="selectedOfferViewer" md="4" lg="3" sm="12" v-if="cStep != RESUMEN_COMPRA">
                    <public-offer :offer-id="form.selectedOffer" non-selectable/>
                </b-col>

                <b-col :md="(cStep != RESUMEN_COMPRA) ? 8 : 12" :lg="(cStep != RESUMEN_COMPRA) ? 9 : 12">

                    <template v-if="cStep == TIPO_SIM">
                        <tipo-sim class="mt-0 mb-2" :debug="debug" />
                        <direccion-envio class="mt-0 mb-2" v-if="form.deliveryFormat == 'physical'" :debug="debug" />
                    </template>


                    <metodo-de-pago class="mt-0 mb-2" v-if="cStep == METODO_DE_PAGO" :debug="debug" />

                    <portabilidad class="mt-0 mb-2" v-if="cStep == PORTABILIDAD" :debug="debug" />

                    <acceso-cuenta-modal ref="accesoCuentaModal" @logged="triggerNextStep" />

                    <procesamiento-compra class="mt-0 mb-2" v-if="cStep == PROCESANDO_COMPRA" :debug="debug"
                        :pmSelected="form.selectedPM"
                        :getBack="getBack" />

                    <resumen-compra class="mt-0 mb-2" v-if="cStep == RESUMEN_COMPRA" :debug="debug"
                        ref="resumenCompra" />

                    <div class="mt-0 mb-2" v-if="cStep == RESULTADO_COMPRA">
                        Resultado de compra
                    </div>

                    <b-card class="text-right mt-4 bg-primary" v-if="cStep != PROCESANDO_COMPRA">
                        <strong class="mr-3">
                            Total: {{ (form.numberOfLines * form.pu) | currency }}
                        </strong>
                        <b-button variant="info" :disabled="isBackDisabled" @click="$router.go(-1)">
                            {{ cBackLabel }}
                        </b-button>
                        <b-button :variant="cStepProgress === stepKeys.length ? 'success' : 'primary'"
                            @click="triggerNextStep" :disabled="isNextDisabled">
                            {{ cNextLabel }}
                        </b-button>
                    </b-card>

                </b-col>

            </b-row>

            <template v-if="debug">
                <pre class="p-4"><code>contrataYa(form): {{ form }}</code></pre>
                <pre class="p-4"><code>stepKeys: {{ stepKeys }}</code></pre>
                <pre class="p-4"><code>cStep: {{ cStep }}</code></pre>
                <pre class="p-4"><code>cNextStep: {{ cStepLabel }}</code></pre>
            </template>
            
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AccesoCuentaModal from './acceso-cuenta-modal'
import direccionEnvio from './direccion-envio';
import ProductsViewer from './products-viewer'
import MetodosPagoStripe from '../../usuario-cuenta/metodos-pago-stripe'
import ProcesamientoCompra from './procesamiento-compra.vue'
import TipoSim from './tipo-sim.vue';
import PublicOffer from './public-offer.vue';
import MetodoDePago from './metodo-de-pago'
import portabilidad from './portabilidad.vue';
import resumenCompra from './resumen-compra.vue';
import contrataYa from './contrataYa';
import { notify } from '@/js/utils';
import {
    SELECCIONA_OFERTA,
    TIPO_SIM,
    PORTABILIDAD,
    DIRECCION_ENVIO,
    ACCESO_CUENTA,
    METODO_DE_PAGO,
    PROCESANDO_COMPRA,
    RESULTADO_COMPRA,
    RESUMEN_COMPRA,
    stepSubtitles,
    stepKeys
} from './contrataConst';

export default {

    name: 'contrataYaLanding',

    components: {
        AccesoCuentaModal,
        MetodoDePago,
        portabilidad,
        ProcesamientoCompra,
        MetodosPagoStripe,
        PublicOffer,
        ProductsViewer,
        direccionEnvio,
        resumenCompra,
        TipoSim
    },

    props: {
        hideProgressBar: {
            type: Boolean,
            default: false
        },
        hideFirstNextBCard: {
            type: Boolean,
            default: true
        },
        disableRedirectOnMount: {
            type: Boolean,
            default: false
        },
        backLabel: {
            type: String,
            default: 'Anterior'
        },
        blockOnUnloggedUser: {
            type: Boolean,
            default: true
        },
        blockOnEmptyPaymentMethod: {
            type: Boolean,
            default: false
        },
        debug: {
            type: Boolean,
            default: false
        },
        stepSubtitles: {
            type: Object,
            default: () => stepSubtitles
        },
        stepKeys: {
            type: Array,
            default: () => stepKeys
        },
        nextLabel: {
            type: String,   // [Continuar|Siguiente|Next]
            default: 'Siguiente'
        },
        finishLabel: {
            type: String,   // [Finalizar|Finish|Complete]
            default: 'Finalizar contratación'
        },
        processingLabel: {
            type: String,   // [Procesando|Processing|Loading]
            default: 'Procesando...'
        },
        unselectedPMLabel: {
            type: String,   // [Selecciona un método de pago|Select a payment method]
            default: 'Selecciona un método de pago'
        },
        onlyMifi: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        ...mapGetters(['isLogged']),
        isBackDisabled() {
            return false;
        },
        isNextDisabled() {
            return (this.cStep == METODO_DE_PAGO && !this.form.selectedPM && this.blockOnEmptyPaymentMethod) ||
                (this.cStep == ACCESO_CUENTA && !this.isLogged && this.blockOnUnloggedUser);
        },
        cNextLabel() {
            return this.cStep == RESUMEN_COMPRA ? this.finishLabel : this.nextLabel;
        },
        cBackLabel() {
            return this.backLabel;
        },
        cStepProgress() {
            return this.stepKeys.indexOf(this.cStep) + 1;
        },
        cStep() {
            return this.$route.params.step || this.stepKeys[0];
        },
        cNextStep() {
            return this.nextStep();
        },
        cStepLabel() {
            switch (this.cStepProgress) {
                case 1:
                    return "Configura tu suscripción";
                case 2:
                    return "Define tu método de pago";
                case 3:
                    return "Procesando la compra";
                default:
                    return "Procesando...";
            }
        },
    },

    data: () => {
        return {
            generalTitle: contrataYa.generalTitle,
            numberOfLines: contrataYa.workingData.numberOfLines,
            form: contrataYa.workingData,
            SELECCIONA_OFERTA,
            TIPO_SIM,
            PORTABILIDAD,
            DIRECCION_ENVIO,
            ACCESO_CUENTA,
            METODO_DE_PAGO,
            PROCESANDO_COMPRA,
            RESULTADO_COMPRA,
            RESUMEN_COMPRA
        };
    },

    methods: {
        nextStep(stepOffset = 0) {
            return this.stepKeys[this.cStepProgress + stepOffset];
        },
        getBack() {
            this.$router.back();
        },
        triggerNextStep() {
            try {
                let nextStep = this.cNextStep;

                if (this.cStep == RESUMEN_COMPRA && !this.$refs.resumenCompra.isAccepted())
                    throw 'Debes aceptar los Términos y Condiciones para continuar.';

                if (!contrataYa.validate(this.cStep))
                    throw 'Rectifica la configuración de tu contratación.';

                if (nextStep == ACCESO_CUENTA && !this.isLogged) {
                    this.$refs.accesoCuentaModal.show();
                    return false;
                } else if (nextStep == ACCESO_CUENTA) {
                    nextStep = this.nextStep(1);
                }

                contrataYa.workingData.step = nextStep;

                this.$router.push({ name: 'contrata-ya', params: { step: contrataYa.workingData.step } }).catch(err => {
                    if (err.name !== 'NavigationDuplicated') {
                        throw err;
                    }
                });

            } catch (e) {
                notify(e, 'warning');
                console.warn(e);
            }
        },
        updatePrice(price) {
            contrataYa.workingData.pu = price
        },
    },

    beforeMount() {
        if (!this.disableRedirectOnMount &&  (contrataYa.workingData.step === null && this.$route.params.step !== this.stepKeys[0]))
            this.$router.replace({ name: 'contrata-ya', params: { step: this.stepKeys[0] } }).catch(this.handleNavigationDuplicated);
    },

    watch: {
        isLogged(){
            if(this.cStep == PORTABILIDAD)
                this.triggerNextStep()
        }
    }
}
</script>

<style lang="scss" scoped>
#contrata-ya-landing {
    background-color: black;
    color: white;

    @media screen and (max-width: 768px) {
        #selectedOfferViewer {
            display: none;
        }
    }
}
</style>